export default __webpack_public_path__ + "static/media/step-3.8dedef51.png";